import { AgendamentoConsultasPlanejadasAtendimentoInput } from 'graphql/types.generated'
import { isObjectDeepEmpty } from 'util/object'

import { convertAgendarConsulta } from './converter-agendarConsultaAtendimento'
import { AgendarProximasConsultasSectionModel } from './model-agendarConsultaAtendimento'

export function convertPlanejadas(
  proximasConsultas: AgendarProximasConsultasSectionModel | undefined,
  showHorarioFinal: boolean = false
): AgendamentoConsultasPlanejadasAtendimentoInput | undefined {
  if (!proximasConsultas) return undefined
  return isObjectDeepEmpty(proximasConsultas)
    ? undefined
    : {
        preNatal: convertAgendarConsulta(proximasConsultas?.proximaConsultaPreNatal, showHorarioFinal),
        odontologica: convertAgendarConsulta(proximasConsultas?.proximaConsultaOdontologica, showHorarioFinal),
      }
}
